/*
Prakash 03/15/2023 3031450488 Added Menu Item Icons.
Suresh Peddavoora 03/15/2023 2780168262 Added test icon  in Action Column in table
Suresh Peddavoora 03/16/2023 2780168262 Added test icon  in Action Column in table
Prakash 03/16/2023 3031450488 Added Custom Action-Icons.
Suresh Peddavoora 03/20/2023 3225736869 Added Visibleicon for Actions Dropdown
Suresh Peddavoora 03/21/2023 3225736869 Removed Visibleicon from Actions Dropdown
Raghu 03/21/2023 3225736869 aligned actions menu
Raghu 03/23/2023 3225736869 aligned actions menu
Ravi  05/04/2023 2700632669 Added reactivate user
Ravi  05/08/2023 2700632669 fixed reactivate user issue
Akhila 05/10/2023 2700632669 modified download for excel file in execution
Sohel 05/17/2023 3075154998 Add Import File Functionality
Akhila 05/17/2023 3075154998 Added Export File Functionality
Akhila 05/18/2023 3075154998 bug fixed label run export
Sohel 05/23/2023 3075154998 Changed Import Test Title
Sohel 12/07/2023 3075154998 Adding unlock user status and payload changes
*/
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import { Menu, Typography } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { makeStyles } from '@material-ui/core/styles';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import HistoryIcon from '@material-ui/icons/History';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ClearIcon from '@material-ui/icons/Clear';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import { ReactComponent as ReactivateIcon } from '../assets/images/reactivateIcon.svg';
import SpeakerNotesOutlinedIcon from '@material-ui/icons/SpeakerNotesOutlined';
import SystemUpdateAltSharpIcon from '@material-ui/icons/SystemUpdateAltSharp';
import LockOpenIcon from '@material-ui/icons/LockOpen';

const useStyles = makeStyles({
  root: {
    width: 230,
  },
  actionsDropdownMain: {
    '& .MuiList-padding ': {
      padding: '0 !important',
    },
  },
  actionsDropdown: {
    padding: '0 !important',
    '& .MuiMenuItem-root': {
      borderBottom: '1px solid #e8e8e8',
    },
    '& .MuiListItemIcon-root': {
      minWidth: '40px !important',
    },
    '& .MuiTypography-root': {
      fontSize: '14px !important',
    },
    '& .MuiSvgIcon-root': {
      fill: '#320469 !important',
      color: '#320469 !important',
    },
  },
  reactivateIcon: {
    width: '20px',
    fill: '#320469 !important',
    color: '#320469 !important',
  },
});

const ActionMenuItem = (props) => {
  const {
    data,
    handleDelete = () => {},
    handleEdit = () => {},
    handleNotes = () => {},
    handleRun = () => {},
    handleExecution = () => {},
    handleCopy = () => {},
    hiddenMenu,
    handleUsage = () => {},
    disableMenu,
    handleUser = () => {},
    handlePassword = () => {},
    handleTest = () => {},
    reactiveUser = () => {},
    handleImportFile = () => {},
    handleExportFile = () => {},
    unlockUser = () => {},
    // handleView = () => {},
  } = props;
  const {
    edit,
    run,
    copy,
    hiddenDelete,
    notes,
    execution,
    usage,
    user,
    password,
    test,
    importFile,
    exportFile,
  } = hiddenMenu;
  const {
    disableEdit,
    disableRun,
    disableCopy,
    disableDelete,
    disableExecution,
    disableNotes,
    disableUsage,
    disableUser,
    disablePassword,
    disableTest,
    // disableView,
    disableImportFile,
    disableExportFile,
    disableUnlockUser,
  } = disableMenu;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleEditMenu = () => {
    handleEdit(data);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteMenu = () => {
    handleDelete(data);
  };
  const handleNotesMenu = () => {
    handleNotes(data);
  };
  const handleUsageMenu = () => {
    handleUsage(data);
  };
  const handleRunMenu = () => {
    handleRun(data);
  };
  const handleExecutionMenu = () => {
    handleExecution(data);
  };
  const handleCopyMenu = () => {
    handleCopy(data);
  };
  const handleUserMenu = () => {
    handleUser(data);
  };
  const reactiveUserMenu = () => {
    reactiveUser(data);
  };
  const handlePasswordMenu = () => {
    handlePassword(data);
  };
  const handleTestMenu = () => {
    handleTest(data);
  };
  const handleImportFileMenu = () => {
    handleImportFile(data);
  };
  const handleExportFileMenu = () => {
    handleExportFile(data);
  };
  const handleUnlockMenu = () => {
    unlockUser(data);
  };
  // const handleViewMenu = () =>{
  //   handleView(data);
  // }
  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Paper className={`${classes.root} `}>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          open={open}
          onClose={handleClose}
          className={classes.actionsDropdownMain}
        >
          <MenuList className={classes.actionsDropdown}>
            {!run && (
              <MenuItem disabled={disableRun} onClick={handleRunMenu}>
                <ListItemIcon>
                  <PlayCircleOutlineOutlinedIcon />
                </ListItemIcon>
                <Typography variant="inherit">Run</Typography>
              </MenuItem>
            )} 
            {!edit && (
              <MenuItem disabled={disableEdit} onClick={handleEditMenu}>
                <ListItemIcon>
                  <EditOutlinedIcon />
                </ListItemIcon>
                <Typography variant="inherit">Edit</Typography>
              </MenuItem>
            )}
            {!copy && (
              <MenuItem disabled={disableCopy} onClick={handleCopyMenu}>
                <ListItemIcon>
                  <FileCopyOutlinedIcon />
                </ListItemIcon>
                <Typography variant="inherit">Copy</Typography>
              </MenuItem>
            )}
            {!hiddenDelete && (
              <MenuItem disabled={disableDelete} onClick={handleDeleteMenu}>
                <ListItemIcon>
                  <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Delete</Typography>
              </MenuItem>
            )}
            {!execution && (
              <MenuItem disabled={disableExecution} onClick={handleExecutionMenu}>
                <ListItemIcon>
                  <HistoryIcon />
                </ListItemIcon>
                <Typography variant="inherit">Executions</Typography>
              </MenuItem>
            )}
            {!notes && (
              <MenuItem disabled={disableNotes} onClick={handleNotesMenu}>
                <ListItemIcon>
                  <DescriptionOutlinedIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Notes</Typography>
              </MenuItem>
            )}
            {!usage && (
              <MenuItem disabled={disableUsage} onClick={handleUsageMenu}>
                <ListItemIcon>
                  <DataUsageIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Usage</Typography>
              </MenuItem>
            )}
            {data.isActive === 'Y' && !user ? (
              <MenuItem disabled={disableUser} onClick={handleUserMenu}>
                <ListItemIcon>
                  <div className="user-clear-icon">
                    <PersonOutlineIcon className="deactivate-user-icon" />
                    <ClearIcon className="deactivate-clear-icon" />
                  </div>
                </ListItemIcon>
                <Typography variant="inherit">Deactivate User</Typography>
              </MenuItem>
            ) : (
              !user && (
                <MenuItem disabled={disableUser} onClick={reactiveUserMenu}>
                  <ListItemIcon>
                    <ReactivateIcon className={classes.reactivateIcon} />
                    {/* <ClearIcon className="activate-clear-icon" /> */}
                  </ListItemIcon>
                  <Typography variant="inherit">Reactivate User</Typography>
                </MenuItem>
              )
            )}
            {!password && (
              <MenuItem disabled={disablePassword} onClick={handlePasswordMenu}>
                <ListItemIcon>
                  <VpnKeyOutlinedIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Change Password</Typography>
              </MenuItem>
            )}
            {!test && (
              <MenuItem disabled={disableTest} onClick={handleTestMenu}>
                <ListItemIcon>
                  <SpeakerNotesOutlinedIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Test</Typography>
              </MenuItem>
            )}
            {importFile && (
              <MenuItem disabled={disableImportFile} onClick={handleImportFileMenu}>
                <ListItemIcon>
                  <SystemUpdateAltSharpIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">Import File</Typography>
              </MenuItem>
            )}
            {exportFile && (
              <MenuItem disabled={disableExportFile} onClick={handleExportFileMenu}>
                <ListItemIcon>
                  <PlayCircleOutlineOutlinedIcon />
                </ListItemIcon>
                <Typography variant="inherit">Run Export</Typography>
              </MenuItem>
            )}
            {/* {!view && (
              <MenuItem disabled={disableView} onClick={handleViewMenu}>
                <ListItemIcon>
                  <VisibilityOutlinedIcon className={classes.copyButtonroot} />
                </ListItemIcon>
                <Typography variant="inherit">View Executions</Typography>
              </MenuItem>
            )} */}
            {data?.isLocked === 'Y' && disableUnlockUser && (
              <MenuItem onClick={handleUnlockMenu}>
                <ListItemIcon>
                  <div className="user-clear-icon">
                    <LockOpenIcon className="deactivate-user-icon" />
                  </div>
                </ListItemIcon>
                <Typography variant="inherit">Unlock User</Typography>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </Paper>
    </div>
  );
};

export default ActionMenuItem;
